import {
  CREATE_SALES_ORDER,
  CREATE_SALES_ORDER_SUCCESS,
  CREATE_SALES_ORDER_FAILURE,
  POSTCODE_LOOKUP,
  POSTCODE_LOOKUP_SUCCESS,
  POSTCODE_LOOKUP_FAILURE,
  GET_RENDER_ECOMMERCE_STORE,
  GET_RENDER_ECOMMERCE_STORE_SUCCESS,
  GET_RENDER_ECOMMERCE_STORE_FAILURE,
  GET_PRODUCT_CATEGORIES,
  GET_PRODUCT_CATEGORIES_SUCCESS,
  GET_PRODUCT_CATEGORIES_FAILURE,
  SEARCH_PRODUCTS_CATEGORY,
  SEARCH_PRODUCTS_CATEGORY_SUCCESS,
  SEARCH_PRODUCTS_CATEGORY_FAILURE,
  CALCULATE_SHIPPING,
  CALCULATE_SHIPPING_SUCCESS,
  CALCULATE_SHIPPING_FAILURE,
  CALCULATE_ORDER_TOTAL,
  CALCULATE_ORDER_TOTAL_SUCCESS,
  CALCULATE_ORDER_TOTAL_FAILURE,
  EXECUTE_ECOMMERCE_STORE,
  EXECUTE_ECOMMERCE_STORE_SUCCESS,
  EXECUTE_ECOMMERCE_STORE_FAILURE,
  GET_ECOMMERCE_DELIVERY_SLOTS,
  GET_ECOMMERCE_DELIVERY_SLOTS_SUCCESS,
  GET_ECOMMERCE_DELIVERY_SLOTS_FAILURE,
} from "./actionType";

const initialState = {
  createSalesOrderLoading: false,
  createSalesOrderError: null,
  createSalesOrderResponse: null,
  postcodeLookupLoading: false,
  postcodeLookupError: null,
  postcodeLookupResponse: null,
  getRenderEcommerceStoreLoading: false,
  getRenderEcommerceStoreError: null,
  getRenderEcommerceStoreResponse: null,
  getProductCategoriesLoading: false,
  getProductCategoriesError: null,
  getProductCategoriesResponse: null,
  searchProductsCategoryLoading: false,
  searchProductsCategoryError: null,
  searchProductsCategoryResponse: null,
  calculateShippingLoading: false,
  calculateShippingError: null,
  calculateShippingResponse: null,
  calculateOrderTotalLoading: false,
  calculateOrderTotalError: null,
  calculateOrderTotalResponse: null,
  executeEcommerceStoreLoading: false,
  executeEcommerceStoreError: null,
  executeEcommerceStoreResponse: null,
  getEcommerceDeliverySlotsLoading: false,
  getEcommerceDeliverySlotsError: null,
  getEcommerceDeliverySlotsResponse: null,
};

const ecommerceReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SALES_ORDER:
      return {
        ...state,
        createSalesOrderLoading: true,
        createSalesOrderError: null,
        createSalesOrderResponse: null,
      };
    case CREATE_SALES_ORDER_SUCCESS:
      return {
        ...state,
        createSalesOrderLoading: false,
        createSalesOrderError: null,
        createSalesOrderResponse: action.payload,
      };
    case CREATE_SALES_ORDER_FAILURE:
      return {
        ...state,
        createSalesOrderLoading: false,
        createSalesOrderError: action.payload,
        createSalesOrderResponse: null,
      };
    case POSTCODE_LOOKUP:
      return {
        ...state,
        postcodeLookupLoading: true,
        postcodeLookupError: null,
        postcodeLookupResponse: null,
      };
    case POSTCODE_LOOKUP_SUCCESS:
      return {
        ...state,
        postcodeLookupLoading: false,
        postcodeLookupError: null,
        postcodeLookupResponse: action.payload,
      };
    case POSTCODE_LOOKUP_FAILURE:
      return {
        ...state,
        postcodeLookupLoading: false,
        postcodeLookupError: action.payload,
        postcodeLookupResponse: null,
      };
    case GET_RENDER_ECOMMERCE_STORE:
      return {
        ...state,
        getRenderEcommerceStoreLoading: true,
        getRenderEcommerceStoreError: null,
        getRenderEcommerceStoreResponse: null,
      };
    case GET_RENDER_ECOMMERCE_STORE_SUCCESS:
      return {
        ...state,
        getRenderEcommerceStoreLoading: false,
        getRenderEcommerceStoreError: null,
        getRenderEcommerceStoreResponse: action.payload,
      };
    case GET_RENDER_ECOMMERCE_STORE_FAILURE:
      return {
        ...state,
        getRenderEcommerceStoreLoading: false,
        getRenderEcommerceStoreError: action.payload,
        getRenderEcommerceStoreResponse: null,
      };
    case GET_PRODUCT_CATEGORIES:
      return {
        ...state,
        getProductCategoriesLoading: true,
        getProductCategoriesError: null,
        getProductCategoriesResponse: null,
      };
    case GET_PRODUCT_CATEGORIES_SUCCESS:
      return {
        ...state,
        getProductCategoriesLoading: false,
        getProductCategoriesError: null,
        getProductCategoriesResponse: action.payload,
      };
    case GET_PRODUCT_CATEGORIES_FAILURE:
      return {
        ...state,
        getProductCategoriesLoading: false,
        getProductCategoriesError: action.payload,
        getProductCategoriesResponse: null,
      };
    case SEARCH_PRODUCTS_CATEGORY:
      return {
        ...state,
        searchProductsCategoryLoading: true,
        searchProductsCategoryError: null,
        searchProductsCategoryResponse: null,
      };
    case SEARCH_PRODUCTS_CATEGORY_SUCCESS:
      return {
        ...state,
        searchProductsCategoryLoading: false,
        searchProductsCategoryError: null,
        searchProductsCategoryResponse: action.payload,
      };
    case SEARCH_PRODUCTS_CATEGORY_FAILURE:
      return {
        ...state,
        searchProductsCategoryLoading: false,
        searchProductsCategoryError: action.payload,
        searchProductsCategoryResponse: null,
      };
    case CALCULATE_SHIPPING:
      return {
        ...state,
        calculateShippingLoading: true,
        calculateShippingError: null,
        calculateShippingResponse: null,
      };
    case CALCULATE_SHIPPING_SUCCESS:
      return {
        ...state,
        calculateShippingLoading: false,
        calculateShippingError: null,
        calculateShippingResponse: action.payload,
      };
    case CALCULATE_SHIPPING_FAILURE:
      return {
        ...state,
        calculateShippingLoading: false,
        calculateShippingError: action.payload,
        calculateShippingResponse: null,
      };
    case CALCULATE_ORDER_TOTAL:
      return {
        ...state,
        calculateOrderTotalLoading: true,
        calculateOrderTotalError: null,
        calculateOrderTotalResponse: null,
      };
    case CALCULATE_ORDER_TOTAL_SUCCESS:
      return {
        ...state,
        calculateOrderTotalLoading: false,
        calculateOrderTotalError: null,
        calculateOrderTotalResponse: action.payload,
      };
    case CALCULATE_ORDER_TOTAL_FAILURE:
      return {
        ...state,
        calculateOrderTotalLoading: false,
        calculateOrderTotalError: action.payload,
        calculateOrderTotalResponse: null,
      };
    case EXECUTE_ECOMMERCE_STORE:
      return {
        ...state,
        executeEcommerceStoreLoading: true,
        executeEcommerceStoreError: null,
        executeEcommerceStoreResponse: null,
      };
    case EXECUTE_ECOMMERCE_STORE_SUCCESS:
      return {
        ...state,
        executeEcommerceStoreLoading: false,
        executeEcommerceStoreError: null,
        executeEcommerceStoreResponse: action.payload,
      };
    case EXECUTE_ECOMMERCE_STORE_FAILURE:
      return {
        ...state,
        executeEcommerceStoreLoading: false,
        executeEcommerceStoreError: action.payload,
        executeEcommerceStoreResponse: null,
      };
    case GET_ECOMMERCE_DELIVERY_SLOTS:
      return {
        ...state,
        getEcommerceDeliverySlotsLoading: true,
        getEcommerceDeliverySlotsError: null,
        getEcommerceDeliverySlotsResponse: null,
      };
    case GET_ECOMMERCE_DELIVERY_SLOTS_SUCCESS:
      return {
        ...state,
        getEcommerceDeliverySlotsLoading: false,
        getEcommerceDeliverySlotsError: null,
        getEcommerceDeliverySlotsResponse: action.payload,
      };
    case GET_ECOMMERCE_DELIVERY_SLOTS_FAILURE:
      return {
        ...state,
        getEcommerceDeliverySlotsLoading: false,
        getEcommerceDeliverySlotsError: action.payload,
        getEcommerceDeliverySlotsResponse: null,
      };
    default:
      return state;
  }
};
export default ecommerceReducer;
